import { createRouter, createWebHistory } from 'vue-router';
import routes from './routes';
import { ensureAccessToken, clearAccessToken } from '../services/auth.service';
import { hubSessionGuard } from './guards/hub-session.guard';

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach(async (to, from, next) => {
  try {
    if (to.meta && to.meta.requiresAuth) {
      await ensureAccessToken();
    }
    next();
  } catch (e) {
    console.error('Falha ao autenticar:', e);
    clearAccessToken();
    next({
      path: '/access-denied',
      query: {
        e: encodeURIComponent('Falha na autenticação. Faça login novamente.'),
        details: '2',
      },
    });
  }
});

router.beforeEach(hubSessionGuard);

export default router;
